<template>
  <b-col v-bind="$attrs" class="mb-4 d-flex">
    <div class="bg-white px-3 py-4 shadow rounded-4 w-100">
      <div class="mb-3">
        <div class="widget-header">
          <div class="widget-header__title">
            <span>
              {{ title }}
              <span :id="`${title} tooltip-info`">
                <i class="mc-fa icon-outline_info"></i>
              </span>
            </span>
            <b-tooltip :target="`${title} tooltip-info`" triggers="hover" placement="bottomRight">
              {{ tooltipText }}
            </b-tooltip>
            <p v-if="subTitle" class="mt-2">{{ subTitle }}</p>
          </div>
          <div v-if="$slots['afterTitle']" class="widget-header__content">
            <slot name="afterTitle" />
          </div>
        </div>
      </div>
      <b-skeleton-wrapper :loading="loading">
        <template #loading>
          <b-skeleton height="250px"></b-skeleton>
        </template>
        <slot />
      </b-skeleton-wrapper>
    </div>
  </b-col>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: false,
    },
    tooltipText: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.widget-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;

  @include xs-screen-only {
    flex-direction: column;
  }

  &__title {
    span {
      font-size: 18px;
      font-weight: 600;
      margin-bottom: 0;
      & > span {
        font-size: 16px;
      }
      color: $mep-color-text;
    }
  }

  &__content {
    flex: 1 1 auto;
    display: flex;

    @include xs-screen-only {
      width: 100%;
    }
  }

  &__content {
    flex: 1 1 auto;
    display: flex;

    @include xs-screen-only {
      width: 100%;
    }
  }
}
</style>
